"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CloserCouponState_1 = require("./CloserCouponState");
var event_bus_1 = require("@idp/event-bus");
var styles = require("./CloserCoupon.scss");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var utils_1 = require("@idp/ui-components/utils");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var CloserCoupon_cms_1 = require("./CloserCoupon.cms");
var ReportingService_1 = require("../../../../api/ReportingService");
var StateProvider_1 = require("../../../../api/StateProvider");
var localdatastore_1 = require("../../../../config/localdatastore");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var Api_1 = require("../../../../api/Api");
var Utils = require("../../../../utils/UtilityFunctions");
var cartUtils = require("../../../../utils/CartUtilFunctions");
var Common = require("../../../../utils/CommonUtilFuntions");
var ClosureCoupon = /** @class */ (function (_super) {
    __extends(ClosureCoupon, _super);
    function ClosureCoupon(props) {
        var _this = _super.call(this, props) || this;
        _this.imageKeys = '';
        _this.availableImages = ['25', '50', '75', '100'];
        _this.availableObservers = [];
        _this.closerCouponWirelineLobs = ['BROADBAND'];
        _this.closerCouponWirelessLobs = ['WIRELESS'];
        _this.isWirelineFlow = false;
        _this.isWirelessFlow = false;
        _this.isPrepaidFlow = false;
        _this.isSMBCustomer = cartUtils.isSMBCustomer();
        _this.state = new CloserCouponState_1.default();
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.bindAll();
        return _this;
    }
    ClosureCoupon.prototype.componentDidMount = function () {
        this.setFlowType();
        this.getCloserCouponCMS();
        if (!this.isWirelessFlow) {
            this.getCouponCode();
        }
        this.registerExitIntent();
        this.registerIdleTimeout();
    };
    ClosureCoupon.prototype.componentWillUnmount = function () {
        this.deregisterObservers();
    };
    ClosureCoupon.prototype.bindAll = function () {
        this.registerExitIntent = this.registerExitIntent.bind(this);
        this.registerIdleTimeout = this.registerIdleTimeout.bind(this);
        this.triggerModal = this.triggerModal.bind(this);
        this.showCloserCouponModal = this.showCloserCouponModal.bind(this);
        this.closeCloserCouponModal = this.closeCloserCouponModal.bind(this);
        this.getCouponCode = this.getCouponCode.bind(this);
        this.deregisterObservers = this.deregisterObservers.bind(this);
        this.getCloserCouponCMS = this.getCloserCouponCMS.bind(this);
        this.setFlowType = this.setFlowType.bind(this);
        this.showWirelessMessageModal = this.showWirelessMessageModal.bind(this);
        this.triggercloseCouponModal = this.triggercloseCouponModal.bind(this);
        this.showWirelessRewardsCouponModal = this.showWirelessRewardsCouponModal.bind(this);
        this.setStateAndReportEvent = this.setStateAndReportEvent.bind(this);
        this.renderCancelButton = this.renderCancelButton.bind(this);
    };
    ClosureCoupon.prototype.render = function () {
        if (this.state.showCloserCouponModal) {
            if (this.state.closerModalType === 'REWARDCARD') {
                return this.showCloserCouponModal();
            }
            if (this.state.closerModalType === 'WIRELESSMESSAGE') {
                return this.showWirelessMessageModal();
            }
            if (this.state.closerModalType === 'WIRELESSREWARDS') {
                return this.showWirelessRewardsCouponModal();
            }
            return (React.createElement(React.Fragment, null));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    ClosureCoupon.prototype.showCloserCouponModal = function () {
        var _this = this;
        var rewardCouponLineOne = this.closerCouponCMS.descriptionLine1;
        var rewardCouponLineTwo = this.closerCouponCMS.descriptionLine2;
        var rewardCouponLineThree = this.closerCouponCMS.descriptionLine3;
        var imageAltText = this.closerCouponCMS.imageAltText;
        if (rewardCouponLineOne) {
            rewardCouponLineOne = rewardCouponLineOne.replace('[[amount]]', this.couponAmount);
        }
        if (rewardCouponLineTwo && this.couponDetails && this.couponDetails.couponCode) {
            rewardCouponLineTwo = rewardCouponLineTwo.replace('[[coupon]]', this.couponDetails.couponCode);
        }
        if (imageAltText) {
            imageAltText = imageAltText.replace('[[amount]]', this.couponAmount);
        }
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('CloserCoupon', 'Modal'), options: {
                center: true,
                className: { modalParentClass: styles.modalParent },
                show: this.state.showCloserCouponModal,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
            }, events: { onClose: function () {
                    _this.triggercloseCouponModal(_this.closerCouponCMS.CTALabel2, ReportingService_1.PageUrls.CLOSER_COUPON_MODAL);
                } } },
            React.createElement("div", { className: styles.couponContainerRow },
                React.createElement("div", { className: [styles.couponContainerColumnFirst].join('') },
                    React.createElement("div", { className: styles.headingContainer },
                        React.createElement(ui_components_1.Label, { data: { text: this.closerCouponCMS.heading }, options: {
                                className: styles.couponHeading,
                                size: LabelProps_1.LabelSizes.MEDIUMHEADING,
                            } })),
                    React.createElement("div", { className: styles.couponLineItem },
                        React.createElement(ui_components_1.Image, { testId: utils_1.default('coupon', 'image'), data: { url: "https://www.att.com/idpassets/buy/checkout/offers/" + this.imageKeys + "_mobile.png" }, options: {
                                alt: imageAltText,
                                className: styles.innerImageStyles,
                                height: '208px',
                                width: '119px',
                            } }),
                        React.createElement("p", { dangerouslySetInnerHTML: {
                                __html: rewardCouponLineOne,
                            } }),
                        React.createElement("p", { dangerouslySetInnerHTML: {
                                __html: rewardCouponLineTwo,
                            } }),
                        React.createElement("p", { dangerouslySetInnerHTML: {
                                __html: rewardCouponLineThree,
                            } })),
                    React.createElement("div", { className: styles.couponButtonContainer },
                        React.createElement(ui_components_1.Button, { testId: utils_1.default('Closercoupon', 'Apply', 'Button'), data: { text: this.closerCouponCMS.CTALabel1 }, options: {
                                size: ButtonProps_1.ButtonSize.LARGE,
                                type: ButtonProps_1.ButtonType.PRIMARY,
                            }, events: { onClick: function () {
                                    _this.applyPromoCode(_this.couponDetails.couponCode, _this.closerCouponCMS.CTALabel1);
                                } } }),
                        this.renderCancelButton(this.closerCouponCMS.CTALabel2))),
                React.createElement("div", { className: styles.couponContainerColumnSecond },
                    React.createElement(ui_components_1.Image, { testId: utils_1.default('coupon', 'image'), data: { url: "https://www.att.com/idpassets/buy/checkout/offers/" + this.imageKeys + "_desktop.png" }, options: {
                            alt: imageAltText,
                            className: styles.imageStyles,
                        } })))));
    };
    ClosureCoupon.prototype.showWirelessRewardsCouponModal = function () {
        var _this = this;
        var rewardCouponLineOne = this.isSMBCustomer ? this.smbCouponCMS.smbRewardsDescriptionLine1 :
            this.wirelessCouponCMS.rewardsdescriptionLine1;
        var rewardCouponLineTwo = this.isSMBCustomer ? this.smbCouponCMS.smbRewardsDescriptionLine2 :
            this.wirelessCouponCMS.rewardsdescriptionLine2;
        var rewardCouponLineThree = this.isSMBCustomer ? this.smbCouponCMS.smbRewardsDescriptionLine3 :
            this.wirelessCouponCMS.rewardsdescriptionLine3;
        var rewardCouponLineFour = this.isSMBCustomer ? this.smbCouponCMS.smbRewardsDescriptionLine4 :
            this.wirelessCouponCMS.rewardsdescriptionLine4;
        var rewardsDetailLabel = this.isSMBCustomer ? this.smbCouponCMS.smbRewardsDetailLabel :
            this.wirelessCouponCMS.rewardsDetailLabel;
        var rewardsDetailsURL = this.isSMBCustomer ? this.smbCouponCMS.smbRewardsDetailsURL :
            this.wirelessCouponCMS.rewardsDetailsURL;
        var imageAltText = this.isSMBCustomer ? this.smbCouponCMS.smbRewardsImageAltText :
            this.wirelessCouponCMS.rewardsimageAltText;
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('CloserCoupon', 'Modal'), options: {
                center: true,
                className: { modalParentClass: styles.modalParent },
                show: this.state.showCloserCouponModal,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
            }, events: { onClose: function () {
                    var ctaLabel = _this.isSMBCustomer ? _this.smbCouponCMS.smbCTALabel2 :
                        _this.wirelessCouponCMS.CTALabel2;
                    _this.triggercloseCouponModal(ctaLabel, ReportingService_1.PageUrls.CLOSER_COUPON_MODAL);
                } } },
            React.createElement("div", { className: styles.couponContainerRow },
                React.createElement("div", { className: [styles.couponContainerColumnFirst].join('') },
                    React.createElement("div", { className: styles.headingContainer },
                        React.createElement(ui_components_1.Label, { data: { text: this.isSMBCustomer ? this.smbCouponCMS.smbRewardsHeading :
                                    this.wirelessCouponCMS.rewardsheading }, options: {
                                className: styles.couponHeading,
                                size: LabelProps_1.LabelSizes.MEDIUMHEADING,
                            } })),
                    React.createElement("div", { className: styles.couponLineItem },
                        React.createElement(ui_components_1.Image, { testId: utils_1.default('coupon', 'image'), data: { url: "https://www.att.com/idpassets/buy/checkout/offers/Wireless_Rewards_100_mobile.png" }, options: {
                                alt: imageAltText,
                                className: styles.innerImageStyles,
                                height: '208px',
                                width: '119px',
                            } }),
                        rewardCouponLineOne &&
                            React.createElement("p", { dangerouslySetInnerHTML: {
                                    __html: rewardCouponLineOne,
                                } }),
                        rewardCouponLineTwo &&
                            React.createElement("p", { dangerouslySetInnerHTML: {
                                    __html: rewardCouponLineTwo,
                                } }),
                        rewardCouponLineThree &&
                            React.createElement("p", { dangerouslySetInnerHTML: {
                                    __html: rewardCouponLineThree,
                                } }),
                        rewardCouponLineFour &&
                            React.createElement("p", { className: styles.modelContentForWireless },
                                React.createElement("span", null, rewardCouponLineFour),
                                rewardsDetailsURL && rewardsDetailLabel &&
                                    React.createElement("a", { href: rewardsDetailsURL, target: "_blank" }, rewardsDetailLabel))),
                    React.createElement("div", { className: styles.couponButtonContainer },
                        React.createElement(ui_components_1.Button, { testId: utils_1.default('Closercoupon', 'Apply', 'Button'), data: { text: this.isSMBCustomer ? this.smbCouponCMS.smbCTALabel1 :
                                    this.wirelessCouponCMS.CTALabel1 }, options: {
                                size: ButtonProps_1.ButtonSize.LARGE,
                                type: ButtonProps_1.ButtonType.PRIMARY,
                            }, events: { onClick: function () {
                                    _this.reportingService.fireLinkClickWithOutPageLoad(_this.isSMBCustomer ?
                                        _this.smbCouponCMS.smbCTALabel1 :
                                        _this.wirelessCouponCMS.CTALabel1, ReportingService_1.PageUrls.CLOSER_COUPON_MODAL);
                                    var rewardsCode;
                                    var ctaLabel1;
                                    var rewardsdisplayName;
                                    var rewardslegalDescription;
                                    var redeemrewardDescription;
                                    var rewardsAmount;
                                    if (_this.isSMBCustomer) {
                                        rewardsCode = _this.smbCouponCMS.smbRewardsCode;
                                        ctaLabel1 = _this.smbCouponCMS.smbCTALabel1;
                                        rewardsdisplayName = _this.smbCouponCMS.smbRewardsDisplayName;
                                        rewardslegalDescription = _this.smbCouponCMS.smbRewardsLegalDescription;
                                        redeemrewardDescription = _this.smbCouponCMS.smbRedeemRewardDescription;
                                        rewardsAmount = _this.smbCouponCMS.smbRewardsAmount;
                                    }
                                    else {
                                        rewardsCode = _this.wirelessCouponCMS.rewardscode;
                                        ctaLabel1 = _this.wirelessCouponCMS.CTALabel1;
                                        rewardsdisplayName = _this.wirelessCouponCMS.rewardsdisplayName;
                                        rewardslegalDescription = _this.wirelessCouponCMS.rewardslegalDescription;
                                        redeemrewardDescription = _this.wirelessCouponCMS.redeemrewardDescription;
                                        rewardsAmount = _this.wirelessCouponCMS.rewardsAmount;
                                    }
                                    _this.applyPromoCode(rewardsCode, ctaLabel1, rewardsdisplayName, rewardslegalDescription, redeemrewardDescription, rewardsAmount);
                                } } }),
                        this.renderCancelButton(this.wirelessCouponCMS.CTALabel2))),
                React.createElement("div", { className: styles.couponContainerColumnSecond },
                    React.createElement(ui_components_1.Image, { testId: utils_1.default('coupon', 'image'), data: { url: "https://www.att.com/idpassets/buy/checkout/offers/Wireless_Rewards_100_desktop.png" }, options: {
                            alt: imageAltText,
                            className: styles.imageStyles,
                        } })))));
    };
    ClosureCoupon.prototype.renderCancelButton = function (cmsvalue) {
        var _this = this;
        var buttonel = (React.createElement(ui_components_1.Button, { testId: utils_1.default('Closercoupon', 'Cancel', 'Button'), data: { text: cmsvalue }, options: {
                size: ButtonProps_1.ButtonSize.LARGE,
                type: ButtonProps_1.ButtonType.TEXT,
            }, events: {
                onClick: function () {
                    _this.triggercloseCouponModal(cmsvalue, ReportingService_1.PageUrls.CLOSER_COUPON_MODAL);
                },
            } }));
        return buttonel;
    };
    ClosureCoupon.prototype.triggercloseCouponModal = function (value, pageurl) {
        this.reportingService.fireLinkClickWithOutPageLoad(value, pageurl);
        this.closeCloserCouponModal();
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
    };
    ClosureCoupon.prototype.showWirelessMessageModal = function () {
        var _this = this;
        var modalrender = (React.createElement(ui_components_1.Modal, { testId: utils_1.default('CloserCoupon', 'Modal'), options: {
                center: true,
                className: { modalParentClass: styles.modalParent },
                show: this.state.showCloserCouponModal,
                showClose: true,
                size: ModalProps_1.ModalSizes.LARGE,
            }, events: { onClose: function () {
                    _this.triggercloseCouponModal(_this.messagingCMS.CTALabel2, ReportingService_1.PageUrls.CLOSER_MESSAGING_MODAL);
                } } },
            React.createElement("div", { className: styles.wirelesscouponcontainer },
                React.createElement("div", { className: styles.wirelessmobilewrapper }),
                React.createElement("div", { className: styles.wirelesscontentcontainer },
                    React.createElement("div", { className: styles.wirelessHeadingContainer },
                        React.createElement(ui_components_1.Label, { data: { text: this.messagingCMS.wirelessheading }, options: {
                                className: styles.wirelessHeading,
                                size: LabelProps_1.LabelSizes.MEDIUMHEADING,
                            } })),
                    React.createElement("div", { className: styles.wirelesssubheading }, this.messagingCMS.wirelesssubheading),
                    React.createElement("div", { className: styles.wirelesslistcontainer },
                        this.closerCouponCMS.wirelessdescription1 &&
                            React.createElement("p", { className: styles.listline },
                                React.createElement("span", { className: styles.checkIcon }, "\u2714"),
                                React.createElement("span", { className: styles.listcontent }, this.messagingCMS.wirelessdescription1)),
                        this.closerCouponCMS.wirelessdescription2 &&
                            React.createElement("p", { className: styles.listline },
                                React.createElement("span", { className: styles.checkIcon }, "\u2714"),
                                React.createElement("span", { className: styles.listcontent }, this.messagingCMS.wirelessdescription2)),
                        this.closerCouponCMS.wirelessdescription3 &&
                            React.createElement("p", { className: styles.listline },
                                React.createElement("span", { className: styles.checkIcon }, "\u2714"),
                                React.createElement("span", { className: styles.listcontent }, this.messagingCMS.wirelessdescription3)),
                        this.closerCouponCMS.wirelessdescription4 &&
                            React.createElement("p", { className: styles.listline },
                                React.createElement("span", { className: styles.checkIcon }, "\u2714"),
                                React.createElement("span", { className: styles.listcontent }, this.messagingCMS.wirelessdescription4)),
                        this.closerCouponCMS.wirelessdescription5 &&
                            React.createElement("p", { className: styles.modelcontent },
                                React.createElement("span", null,
                                    this.messagingCMS.wirelessdescription5,
                                    " "),
                                this.messagingCMS.wirelessdetailsURL &&
                                    this.messagingCMS.wirelessdetailsLabel &&
                                    React.createElement("a", { href: this.messagingCMS.wirelessdetailsURL, target: "_blank" }, this.messagingCMS.wirelessdetailsLabel))),
                    React.createElement("div", { className: styles.wirelessButtonContainer },
                        React.createElement(ui_components_1.Button, { testId: utils_1.default('Closercoupon', 'Return to cart', 'Button'), data: { text: this.messagingCMS.CTALabel1 }, options: {
                                className: styles.modalButtons1,
                            }, events: { onClick: function () {
                                    _this.triggercloseCouponModal(_this.messagingCMS.CTALabel1, ReportingService_1.PageUrls.CLOSER_MESSAGING_MODAL);
                                } } }),
                        !Utils.isAuthuser() && React.createElement(ui_components_1.Button, { testId: utils_1.default('Closercoupon', 'Save Cart', 'Button'), data: { text: this.messagingCMS.saveCartCTA }, options: {
                                className: styles.modalButtons1,
                            }, events: { onClick: function () {
                                    _this.reportingService.fireLinkClickWithOutPageLoad(_this.closerCouponCMS.saveCartCTA, ReportingService_1.PageUrls.SAVE_CART_URL);
                                    _this.closeWirelessCouponModal();
                                } } }))))));
        return this.isPrepaidFlow ? null : modalrender;
    };
    ClosureCoupon.prototype.setFlowType = function () {
        var currentLobList = Utils.getCurrentLOBList();
        if (currentLobList && currentLobList.length > 0) {
            this.isWirelineFlow = this.closerCouponWirelineLobs.some(function (ele) { return currentLobList.includes(ele); });
            this.isWirelessFlow = this.closerCouponWirelessLobs.some(function (ele) { return currentLobList.includes(ele); });
            this.isPrepaidFlow = (Utils.getCurrentFlowType() === Utils.LOBNames.LOB_PREPAID);
        }
    };
    ClosureCoupon.prototype.applyPromoCode = function (promoCode, btnText, displayName, legaltext, rewardsDetails, rewardsamt) {
        var couponCodeObj = { couponCode: promoCode, displayName: displayName,
            legaltext: legaltext, rewardsDetails: rewardsDetails, rewardsamt: rewardsamt, triggerType: btnText };
        this.props.events.applyCoupon(couponCodeObj);
        this.closeCloserCouponModal();
    };
    ClosureCoupon.prototype.closeCloserCouponModal = function () {
        this.setState({ showCloserCouponModal: false });
    };
    ClosureCoupon.prototype.closeWirelessCouponModal = function () {
        this.setState({ showCloserCouponModal: false }, this.props.events.showSaveCartModal);
    };
    ClosureCoupon.prototype.getCloserCouponCMS = function () {
        var closerCouponCMSData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout');
        if (closerCouponCMSData && closerCouponCMSData.content &&
            closerCouponCMSData.content.closureCoupon && closerCouponCMSData.content.closureCoupon.rewardCardOffer) {
            this.closerCouponCMS = closerCouponCMSData.content.closureCoupon.rewardCardOffer;
        }
        else {
            this.closerCouponCMS = new CloserCoupon_cms_1.ClosureCouponCms();
        }
        if (closerCouponCMSData && closerCouponCMSData.content &&
            closerCouponCMSData.content.closureCoupon && closerCouponCMSData.content.closureCoupon.wirelessrewards) {
            this.wirelessCouponCMS = closerCouponCMSData.content.closureCoupon.wirelessrewards;
        }
        else {
            this.wirelessCouponCMS = new CloserCoupon_cms_1.ClosureCouponCms();
        }
        if (closerCouponCMSData && closerCouponCMSData.content &&
            closerCouponCMSData.content.closureCoupon && closerCouponCMSData.content.closureCoupon.messagingOffer) {
            this.messagingCMS = closerCouponCMSData.content.closureCoupon.messagingOffer;
        }
        else {
            this.messagingCMS = new CloserCoupon_cms_1.ClosureCouponCms();
        }
        if (closerCouponCMSData && closerCouponCMSData.content &&
            closerCouponCMSData.content.closureCoupon && closerCouponCMSData.content.closureCoupon.smbRewards) {
            this.smbCouponCMS = closerCouponCMSData.content.closureCoupon.smbRewards;
        }
        else {
            this.smbCouponCMS = new CloserCoupon_cms_1.ClosureCouponCms();
        }
    };
    ClosureCoupon.prototype.getCouponCode = function () {
        var _this = this;
        var cartCouponKey = '';
        if (this.closerCouponCMS.closerCouponFlag) {
            if (this.isWirelineFlow) {
                cartCouponKey = this.closerCouponCMS.wirelineCartCouponKey;
            }
            if (this.isWirelessFlow) {
                cartCouponKey = this.closerCouponCMS.wirelessCartCouponKey;
            }
        }
        this.api.getCloserCoupon(cartCouponKey).then(function (response) {
            if (response && response.content && response.content.payload && response.content.payload &&
                response.content.payload.closerCouponDetails.length > 0) {
                if (response.content.payload.closerCouponDetails[0] &&
                    response.content.payload.closerCouponDetails[0].couponCode) {
                    _this.couponDetails = { couponCode: response.content.payload.closerCouponDetails[0].couponCode };
                    _this.couponAmount = _this.formatAmount(response.content.payload.closerCouponDetails[0].amount);
                }
                if (_this.couponAmount &&
                    _this.availableImages.includes(_this.couponAmount)) {
                    _this.imageKeys = 'Coupon_' + _this.couponAmount;
                }
                else {
                    _this.imageKeys = 'Coupon_default';
                }
            }
        });
    };
    ClosureCoupon.prototype.getRewardMessage = function () {
        var rewardsflag = false;
        if (!cartUtils.getCloserCouponFlag()) {
            rewardsflag = false;
        }
        else if (cartUtils.getPostpaidflowtype() !== 'UP' && cartUtils.getPostpaidflowtype() !== 'AL'
            && this.wirelessCouponCMS.rewardswirelessflag) {
            rewardsflag = true;
        }
        else if (cartUtils.getPostpaidflowtype() === 'UP' && cartUtils.getPostpaidflowtype() !== 'AL'
            && this.wirelessCouponCMS.rewardsupgradeflag) {
            rewardsflag = true;
        }
        else if (cartUtils.getPostpaidflowtype() !== 'UP' && cartUtils.getPostpaidflowtype() === 'AL'
            && this.wirelessCouponCMS.rewardsaddlineflag) {
            rewardsflag = true;
        }
        return rewardsflag;
    };
    ClosureCoupon.prototype.getSMBRewardMessage = function () {
        var smbRewardsFlag = false;
        if (cartUtils.getPostpaidflowtype() !== 'UP' && cartUtils.getPostpaidflowtype() !== 'AL'
            && this.smbCouponCMS.smbRewardsWirelessFlag) {
            smbRewardsFlag = true;
        }
        else if (cartUtils.getPostpaidflowtype() === 'UP' && cartUtils.getPostpaidflowtype() !== 'AL'
            && this.smbCouponCMS.smbRewardsUpgradeFlag) {
            smbRewardsFlag = true;
        }
        else if (cartUtils.getPostpaidflowtype() !== 'UP' && cartUtils.getPostpaidflowtype() === 'AL'
            && this.smbCouponCMS.smbRewardsAddLineFlag) {
            smbRewardsFlag = true;
        }
        return smbRewardsFlag;
    };
    ClosureCoupon.prototype.formatAmount = function (amount) {
        if (amount) {
            amount = amount.toString();
            var amountSplit = amount.split('.');
            return amountSplit[0];
        }
        return amount;
    };
    ClosureCoupon.prototype.registerExitIntent = function () {
        var _this = this;
        var exitIntentObserverID = event_bus_1.ICCEventBusManager.getUUID();
        var exitIntentObserver = {
            eventHandler: function (data) { _this.triggerModal('VIEWFRAMEEXITED'); },
            observerId: exitIntentObserverID,
            serviceName: 'appShell:VIEWFRAMEEXITED',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(exitIntentObserver);
        this.availableObservers.push(exitIntentObserverID);
    };
    ClosureCoupon.prototype.registerIdleTimeout = function () {
        var _this = this;
        var idleTimeOutObserverID = event_bus_1.ICCEventBusManager.getUUID();
        var idleTimeoutObserver = {
            eventHandler: function (data) { _this.triggerModal('IDLETIMEOUT'); },
            observerId: idleTimeOutObserverID,
            serviceName: 'appShell:IDLETIMEOUT',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(idleTimeoutObserver);
        this.availableObservers.push(idleTimeOutObserverID);
    };
    ClosureCoupon.prototype.deregisterObservers = function () {
        this.availableObservers.forEach(function (element) {
            event_bus_1.ICCEventBusManager.getInstance().deregisterObserver(element);
        });
        this.availableObservers = [];
    };
    ClosureCoupon.prototype.triggerModal = function (triggerSessionKey) {
        var isAnyModalOpen = Common.isModalOpen();
        var closerCouponDisplayDetails = this.stateManager.get(localdatastore_1.getNamespace('CART'), 'closerCouponDetails');
        if (!(closerCouponDisplayDetails && closerCouponDisplayDetails.couponModalDisplayed) &&
            this.couponDetails && !isAnyModalOpen && !cartUtils.isIncompleteCart()
            && !cartUtils.isPrivateOffersApplied()) {
            this.setState({ showCloserCouponModal: true, closerModalType: 'REWARDCARD' });
            this.stateManager.set('closerCouponDetails', { couponModalDisplayed: true });
            var sessionTriggerData = this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), triggerSessionKey);
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CLOSER_COUPON_MODAL, true, this.getPageTrigger(sessionTriggerData));
        }
        else if (!(closerCouponDisplayDetails && closerCouponDisplayDetails.couponModalDisplayed) && !isAnyModalOpen
            && this.isWirelessFlow && !this.isPrepaidFlow && !cartUtils.getEAPDetails().isEAPFlow &&
            !cartUtils.isIncompleteCart() && !cartUtils.isPrivateOffersApplied()) {
            if (this.isSMBCustomer) {
                if (this.getSMBRewardMessage()) {
                    this.setState({ showCloserCouponModal: true, closerModalType: 'WIRELESSREWARDS' });
                    this.setStateAndReportEvent(triggerSessionKey, true);
                }
            }
            else {
                if (this.getRewardMessage()) {
                    this.setState({ showCloserCouponModal: true, closerModalType: 'WIRELESSREWARDS' });
                    this.setStateAndReportEvent(triggerSessionKey, true);
                }
                else if (cartUtils.isWirelessPropMessagingEnabled()) {
                    this.setState({ showCloserCouponModal: true, closerModalType: 'WIRELESSMESSAGE' });
                    this.setStateAndReportEvent(triggerSessionKey, false);
                }
            }
        }
    };
    ClosureCoupon.prototype.setStateAndReportEvent = function (triggerSessionKey, isWirelessRewards) {
        this.stateManager.set('closerCouponDetails', { couponModalDisplayed: true });
        var sessionTriggerData = this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), triggerSessionKey);
        var pageUrl = isWirelessRewards ? ReportingService_1.PageUrls.CLOSER_COUPON_MODAL : ReportingService_1.PageUrls.CLOSER_MESSAGING_MODAL;
        this.reportingService.firePageLoadEvent(pageUrl, true, this.getPageTrigger(sessionTriggerData));
    };
    ClosureCoupon.prototype.getPageTrigger = function (data) {
        var pageTriggerValue = '';
        if (data && data.action) {
            if (data.action.toUpperCase() === 'MOUSEOUT') {
                pageTriggerValue = 'Mouse Move';
            }
            else if (data.action.toUpperCase() === 'BLUR') {
                pageTriggerValue = 'Keyboard Click';
            }
            else if (data.action.toUpperCase() === 'IDLETIMEOUT') {
                pageTriggerValue = 'Idle Time';
            }
        }
        return pageTriggerValue;
    };
    return ClosureCoupon;
}(React.Component));
exports.default = ClosureCoupon;
//# sourceMappingURL=CloserCoupon.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/CloserCoupon/CloserCoupon.js
// module id = 2246
// module chunks = 8